import React, { Component } from 'react';
import styles from './Technology.module.css';
import { Link } from 'react-router-dom';
import Slide from 'react-reveal/Slide';

import logo from '../../images/CVE_logo_shadow.svg';
import techImg from "../../images/tech.jpg";
import catfishImg from "../../images/catfish.png";
import diagram from '../../images/RAS_FINAL.png'

import Menu from '../../containers/Menu/Menu';
import IntroSection from '../../components/IntroSection/IntroSection';
import AccordionList from '../../components/AccordionList/AccordionList';
import accordionImg1 from '../../images/baleine1.jpg';
import accordionImg2 from '../../images/baleine2.jpg';
import accordionImg3 from '../../images/baleine3.jpg';
import accordionImg4 from '../../images/baleine4.jpg';
import accordionImg5 from '../../images/baleine5.jpg';

export default class Technology extends Component {
  render() {
    let accordionContent = [
      {
        heading: "Clear and Pure",
        description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet",
        image: accordionImg1
      },
      {
        heading: "Safe and traceable",
        description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet",
        image: accordionImg2
      },
      {
        heading: "Resource efficient",
        description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet",
        image: accordionImg3
      },
      {
        heading: "Scalable and flexible",
        description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet",
        image: accordionImg4
      },
      {
        heading: "Responsible food production",
        description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet",
        image: accordionImg5
      },

    ]
    return (
      <div className={styles.Technology}>
        <Menu strokeColor="#000" />
        <div className={styles.nav}>
          <div className={styles.left}>
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className={styles.right}>
            {/* <div>
              {
                [...Array(4)].map((_, index) => {
                  if (index === (indicator - 1)) {
                    return <div key={index} style={{ width: '15px', transition: 'width 0.1s ease-out' }} />
                  } else {
                    return <div key={index} />
                  }
                })
              }
            </div> */}
          </div>
        </div>
        <IntroSection heading="Our clean technology" textImg={techImg} description="CVE Farms dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore" />
        <section className={styles.imgSection}>
          <div className={styles.imgWrapperLeft}>
            <Slide left>
              <img src={catfishImg} alt="catfish" />
            </Slide>
          </div>
          <div className={styles.description}>
            <div>
              <h2>Loremantium Aquaculture Systems</h2>
              <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore</p>
            </div>
          </div>
        </section>
        {/* <section className={styles.videoSection}>
          <h1>Lorem ipsum dolor sit amet fer consetetur sadipscing elitr?</h1>
          <video src=""></video>
        </section> */}
        <section className={styles.accordion}>
          <AccordionList content={accordionContent} />
        </section>
        <section className={styles.imgSection}>
          <div className={styles.left}>
            <Slide bottom cascade>
              <h2>Lorem ipsum dolor sit amet, consetetur sadipscing elitr</h2>
            </Slide>
            <Slide bottom cascade big>
              <ol>
                <li>OPTIMAL FILTERING</li>
                <li>PROPRIETARY OXYGEN DISSOLVING SYSTEM</li>
                <li>ENERGY SAVING SOLUTION</li>
                <li>PROPRIETARY RELIABLE INDOOR DESIGN</li>
                <li>FULL BIO-SECURITY CONTROL</li>
                <li>MONITORING AND CONTROL</li>
                <li>SCALABLE DESIGN</li>
                <li>LOREM IPSUM DOLOR SET AMER</li>
                <li>INDUSTRIAL PRODUCTION TANKS</li>
              </ol>
            </Slide>
            <Slide bottom cascade>
              <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna</p>
            </Slide>
          </div>
          <div className={styles.right}>
            <Slide right>
              <img src={diagram} alt="catfish" />
            </Slide>
          </div>
        </section>
      </div>
    )
  }
}
